import { HttpClient } from "@angular/common/http";
import {Injectable} from "@angular/core";
import { Observable } from "rxjs";

import {Controller} from "../../interface/controller.interface";
import { CategoryProductDTO } from "../../model/club-gigot/inventory-points/product-category/category-product.dto";
import { InventoryProductDTO } from "../../model/club-gigot/inventory-points/product/inventory-product.dto";
import { SaveInventoryProductDTO } from "../../model/club-gigot/inventory-points/product/save-inventory-product.dto";
import { HTTPMethod } from "../../model/http-method.enum";
import { HTTPRequestBuilder } from "../../model/http.request.model";
import {EnvironmentService} from "../environment.service";
import {HTTPService} from "../http.service";
import {
    SaveInventoryGigotProductDto
} from "../../model/club-gigot/inventory-points/product/save-inventory-gigot-product.dto";
import {QueryParamsModel, QueryResultsModel} from "../../core/_base/crud";

/**
	 * @description
	 *  Servicio reflejo del controlador Inventory.
	 */

@Injectable({ providedIn: "root" })
export class InventoryService implements Controller {

    constructor(private httpService: HTTPService, private environmentService: EnvironmentService, private httpClient: HttpClient) {}

    public hostPath() : string {
        return this.environmentService.rewardsBackendHost.href;
    }

    public basePath(): string {
        return "api/inventory";
    }

    public getProducts(query: QueryParamsModel): Observable<QueryResultsModel>{
        return this.httpService.send<QueryParamsModel, QueryResultsModel>(
            new HTTPRequestBuilder<QueryParamsModel>()
                .host(this.hostPath())
                .method(HTTPMethod.POST)
                .controllerPath(this.basePath())
                .relativePath('inventory-products')
                .payload(query)
                .build());
    }

    public getProduct(id : number) : Observable<InventoryProductDTO>{
        return this.httpService.send<typeof undefined, InventoryProductDTO>(
            new HTTPRequestBuilder<typeof undefined>()
                .host(this.hostPath())
                .method(HTTPMethod.GET)
                .controllerPath(this.basePath())
                .relativePath(`inventory-product/${id}`)
                .build());
    }

    // TODO: Hacer un payload en el HTTPRequestBuilder para FromForm (formData)
    public saveProduct(data : SaveInventoryProductDTO) : Observable<void> {
        const formData = new FormData();
        for (const key of Object.keys(data)) {
            const value = data[key];
            if(value)
                formData.append(key, value);
        }

        const url = `${this.hostPath()}${this.basePath()}/inventory-product`;

        if(data.id)
            return this.httpClient.patch<void>(url, formData)
        return this.httpClient.post<void>(url, formData)
    }

    public deleteProduct(id : number) : Observable<void> {
        return this.httpService.send<typeof undefined, null>(
            new HTTPRequestBuilder<typeof undefined>()
                .host(this.hostPath())
                .method(HTTPMethod.DELETE)
                .controllerPath(this.basePath())
                .relativePath(`inventory-product/${id}`)
                .build());
    }

    public createGigotProduct(data : SaveInventoryGigotProductDto[]) : Observable<void> {
        return this.httpService.send<SaveInventoryGigotProductDto[], null>(
            new HTTPRequestBuilder<SaveInventoryGigotProductDto[]>()
                .host(this.hostPath())
                .method(HTTPMethod.POST)
                .controllerPath(this.basePath())
                .relativePath(`inventory-gigot-products`)
                .payload(data)
                .build());
    }
}
